import ApiConfig from '../config/ApiConfig';
import {
  STATUS_200,
  STATUS_300,
  STATUS_401,
  STATUS_403,
} from '../data/constants';
import axios from 'axios';
import { errorMessage } from '../lib/helper';
import { toast } from 'react-toastify';
import { saved, saving, couldnotSave, resetStatus } from '../redux/saveSlice';
import { setConsultantsData } from '../redux/consultantsSlice';

const showErrorMessage = (e) => {
  if (e?.data?.status !== STATUS_401 && e?.data?.status !== STATUS_403) {
    toast.error(errorMessage(e), {
      autoClose: 2500,
    });
  }
};
export const getConsultantsTabsDetails = async (payload, dispatch) => {
  try {
    const resp = await axios.post(
      `${ApiConfig.consultantsTabsAndDetails}`,
      payload
    );
    if (resp?.data?.status >= STATUS_200 && resp?.data?.status < STATUS_300) {
      dispatch(setConsultantsData(resp?.data?.data));
      return resp?.data?.data;
    } else {
      throw resp;
    }
  } catch (e) {
    showErrorMessage(e);
    return false;
  }
};
export const saveAnswers = async (payload, dispatch) => {
  try {
    dispatch(saving());
    const resp = await axios.post(
      `${ApiConfig.saveAnswerForConsultantsQuestions}`,
      payload
    );
    if (resp?.data?.status >= STATUS_200 && resp?.data?.status < STATUS_300) {
      dispatch(saved());
      return true;
    } else {
      dispatch(couldnotSave());
      setTimeout(() => {
        dispatch(resetStatus());
      }, 10000);
      throw resp;
    }
  } catch (e) {
    dispatch(couldnotSave());
    setTimeout(() => {
      dispatch(resetStatus());
    }, 10000);
    showErrorMessage(e);
    return false;
  }
};

export const aiProposalWritingService = async (payload) => {
  try {
    const resp = await axios.post(`${ApiConfig.aiProposalWriting}`, payload);
    if (resp?.data?.status >= STATUS_200 && resp?.data?.status < STATUS_300) {
      return true;
    } else {
      throw resp;
    }
  } catch (e) {
    showErrorMessage(e);
    return false;
  }
};

export const fetchProposalWriting = async (payload) => {
  try {
    const resp = await axios.post(`${ApiConfig.getProposalWriting}`, payload);
    if (resp?.data?.status >= STATUS_200 && resp?.data?.status < STATUS_300) {
      return resp?.data?.data;
    } else {
      throw resp;
    }
  } catch (e) {
    showErrorMessage(e);
    return false;
  }
};

export const aiRfpMatchingService = async (payload) => {
  try {
    const resp = await axios.post(`${ApiConfig.aiRfpMatching}`, payload);
    if (resp?.data?.status >= STATUS_200 && resp?.data?.status < STATUS_300) {
      return true;
    } else {
      throw resp;
    }
  } catch (e) {
    showErrorMessage(e);
    return false;
  }
};

export const fetchRfpMatching = async (payload) => {
  try {
    const resp = await axios.post(`${ApiConfig.getRfpMatching}`, payload);
    if (resp?.data?.status >= STATUS_200 && resp?.data?.status < STATUS_300) {
      return resp?.data?.data;
    } else {
      throw resp;
    }
  } catch (e) {
    showErrorMessage(e);
    return false;
  }
};
